import { Container } from '@/ui/design-system/Container'
import { Button } from '@/ui/components'
import { motion, useInView, useReducedMotion } from 'framer-motion'
import { useRef } from 'react'

export function FinalCTA() {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true, amount: 0.3 })
  const reducedMotion = useReducedMotion()
  const inView = reducedMotion || isInView

  return (
    <section ref={sectionRef} className="py-20 bg-earth-50">
      <Container size="app">
        <motion.div
          className="text-center max-w-2xl mx-auto"
          initial={reducedMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.6, -0.05, 0.01, 0.99] as const }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Ready to plan the next one?
          </h2>
          <motion.p
            className="text-xl text-muted-foreground mb-10 leading-relaxed"
            initial={reducedMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.6, delay: 0.2, ease: [0.6, -0.05, 0.01, 0.99] as const }}
          >
            Routes, crew, meals, gear, and weather in one workspace, shared on your terms.
          </motion.p>
          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={reducedMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.6, delay: 0.4, ease: [0.6, -0.05, 0.01, 0.99] as const }}
          >
            <Button size="lg" asChild>
              <a href="/signup">Start Planning Your First Trip</a>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <a href="/join">Join an Existing Trip</a>
            </Button>
          </motion.div>
        </motion.div>
      </Container>
    </section>
  )
}
